import * as React from 'react';
import { StandardPageLayout } from '../common/StandardPageLayout';
import IntroSegment from './IntroSegment';
import NotFoundImageSegment from './NotFoundImageSegment';
// import HomeButtonSegment from './HomeButtonSegment';

const PageNotFoundLayout = () =>
  <StandardPageLayout id="page-not-found" activeMenu="404">

    <IntroSegment />

    <NotFoundImageSegment />

    {/* <HomeButtonSegment /> */}

  </StandardPageLayout>

export default PageNotFoundLayout



// WEBPACK FOOTER //
// ./src/page-not-found/PageNotFoundLayout.tsx